import {
  useEffect,
  useState,
  type ComponentType,
} from "react";

import { useNavigate } from "react-router-dom";

type RemoteComponent =
  ComponentType<Record<string, unknown>>;

type UseSuccessReturn = {
  handleLogin: () => void;
  Button: RemoteComponent | null;
  loading: boolean;
  submitting: boolean;
  authToken: string;
};

export default function useSuccess():
UseSuccessReturn {

  const [Button, setButton] =
    useState<RemoteComponent | null>(
      null
    );

  const [authToken, setAuthToken] =
    useState("");

  const [authorized, setAuthorized] =
    useState(false);

  const [validating, setValidating] =
    useState(true);

  const [submitting, setSubmitting] =
    useState(false);

  const navigate = useNavigate();

  useEffect(() => {

    const initialize = async () => {

      try {

        const token =
          sessionStorage.getItem(
            "AUTH_TOKEN"
          );

        const type =
          sessionStorage.getItem(
            "AUTH_TYPE"
          );

        if (!token || !type) {

          navigate("/", {
            replace: true,
          });

          return;
        }

        setAuthToken(token);

        const response =
          await fetch(
            `${import.meta.env.VITE_API_URL}/api/amibit/fwp/validate`,
            {
              method: "POST",
              headers: {
                "Content-Type":
                  "application/json",
              },
              body: JSON.stringify({
                token,
                type: Number(type),
              }),
            }
          );

        if (!response.ok) {

          throw new Error(
            `Validation failed: ${response.status}`
          );

        }

        const data =
          await response.json();

        if (!data.success) {

          navigate("/", {
            replace: true,
          });

          return;
        }

        setAuthorized(true);

        const buttonModule =
          await import(
            "remote_app/Button"
          );

        setButton(
          () =>
            buttonModule.default as RemoteComponent
        );

      } catch (error) {

        console.error(
          "Token validation error:",
          error
        );

        navigate("/", {
          replace: true,
        });

      } finally {

        setValidating(false);

      }
    };

    initialize();

  }, [navigate]);

  const handleLogin = (): void => {

    if (submitting) return;

    setSubmitting(true);

    sessionStorage.removeItem(
      "userId"
    );

    sessionStorage.removeItem(
      "invalidEmail"
    );

    sessionStorage.removeItem(
      "name"
    );

    sessionStorage.removeItem(
      "token"
    );

    setTimeout(() => {

      navigate("/login");

      setSubmitting(false);

    }, 500);
  };

  return {
    handleLogin,
    Button,
    authToken,
    submitting,
    loading:
      validating ||
      !authorized ||
      !Button,
  };
}